module.exports = __webpack_public_path__ + "static/media/marketoHero2x.5bea96a0.png";